export const MOBILE_HEADER_CONTAINER_CLASS = "bg-[#F0F0EB] px-2.5 pt-1.5 pb-1";
export const MOBILE_HEADER_CONTAINER_SCROLLED_CLASS =
  "bg-[#F0F0EB]/95 backdrop-blur-sm px-2.5 pt-1.5 pb-1 shadow-[0_4px_12px_rgba(0,0,0,0.06)]";
export const MOBILE_HEADER_TOP_ROW_CLASS = "flex items-center justify-between gap-1.5 h-9 mb-1";
export const MOBILE_HEADER_SECOND_ROW_CLASS = "flex items-center gap-1.5 h-9";
export const MOBILE_HEADER_TITLE_CLASS = "text-[12px] font-black text-gray-700";
export const MOBILE_HEADER_SEARCH_WRAPPER_CLASS = "relative flex-1 min-w-0";
export const MOBILE_HEADER_SEARCH_ICON_CLASS = "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400";
export const MOBILE_HEADER_SORT_GROUP_CLASS = "flex items-center gap-1";
export const MOBILE_HEADER_SORT_SELECT_WRAPPER_CLASS = "relative shrink-0 w-[82px]";
export const MOBILE_HEADER_SORT_LABEL_CLASS = "text-[11px] font-bold";
export const MOBILE_HEADER_SORT_ICON_SIZE = 14;
export const MOBILE_HEADER_COUNT_BADGE_CLASS =
  "shrink-0 bg-white border border-gray-200 h-8 px-2.5 rounded-xl flex items-center justify-center shadow-sm";
export const MOBILE_HEADER_COUNT_TEXT_CLASS = "text-[11px] font-bold text-gray-500";
export const MOBILE_HEADER_COUNT_HIGHLIGHT_CLASS = "text-[#354F38] text-sm font-black";
